/*
  <search-shop-tiles> — search drawer product tiles.

  Copies the image tiles from the mobile drawer's Shop submenu
  (sections/mobile_navig.liquid → .mnavig_subul with .mnavig_img) so the
  search panel and the drawer always show the same tiles. Edit them in the
  customiser under Header → Mobile Navigation; nothing here needs changing.
*/
class SearchShopTiles extends HTMLElement {
  connectedCallback() {
    this.build();

    if (window.Shopify && window.Shopify.designMode) {
      this.onSectionLoad = () => this.build();
      document.addEventListener('shopify:section:load', this.onSectionLoad);
      document.addEventListener('shopify:block:select', this.onSectionLoad);
    }
  }

  disconnectedCallback() {
    if (this.onSectionLoad) {
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      document.removeEventListener('shopify:block:select', this.onSectionLoad);
    }
  }

  build() {
    const list = this.querySelector('.search__tiles-grid');
    const source = [...document.querySelectorAll('.mnavig_subul')].find((ul) =>
      ul.querySelector('.mnavig_img')
    );

    if (!list || !source) {
      this.hidden = true;
      return;
    }

    const label = source
      .closest('.mnavig_li')
      ?.querySelector('.mnavig_text')
      ?.textContent.trim();
    if (label) list.setAttribute('aria-label', label);

    const items = [...source.querySelectorAll('.mnavig_sublink')].map((src) => {
      const li = document.createElement('li');
      li.className = 'search__tile';

      const a = document.createElement('a');
      a.className = 'search__tile-link';
      a.href = src.getAttribute('href') || '#';

      const srcBox = src.querySelector('.mnavig_img');
      const srcImg = srcBox?.querySelector('img');
      if (srcImg) {
        const box = document.createElement('span');
        box.className = 'search__tile-media';
        // Carries the per-tile background/border set on the drawer block.
        const boxStyle = srcBox.getAttribute('style');
        if (boxStyle) box.setAttribute('style', boxStyle);

        const img = document.createElement('img');
        img.alt = '';
        img.width = 140;
        img.height = 140;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.src = this.sized(srcImg.getAttribute('src'), 140);
        // Tile renders at 70px, so 140 covers 2x screens and 210 covers 3x.
        img.srcset = `${this.sized(srcImg.getAttribute('src'), 140)} 2x, ${this.sized(srcImg.getAttribute('src'), 210)} 3x`;
        box.append(img);
        a.append(box);
      }

      const text = document.createElement('span');
      text.className = 'search__tile-text';
      text.textContent = src.querySelector('.mnavig_sublink_text')?.textContent.trim() || '';
      a.append(text);

      li.append(a);
      return li;
    });

    list.replaceChildren(...items);
    this.hidden = items.length === 0;
  }

  sized(src, width) {
    try {
      const url = new URL(src, window.location.href);
      url.searchParams.set('width', width);
      return url.toString();
    } catch (e) {
      return src;
    }
  }
}

if (!customElements.get('search-shop-tiles')) {
  customElements.define('search-shop-tiles', SearchShopTiles);
}
